'use client';

import { useEffect, useState } from 'react';

/**
 * Scroll to Top Button Component
 * 
 * Sayfanın yukarısına smooth scroll yapan buton
 * Yaratıcı animasyonlar ve efektlerle geliştirilmiş
 */
export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // 300px aşağı kaydırıldığında butonu göster
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        // Scroll event listener ekle
        window.addEventListener('scroll', toggleVisibility);

        // Cleanup
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button type="button"
            onClick={scrollToTop}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={`fixed z-[9998] origin-bottom-right bg-white rounded-full shadow-lg border border-gray-200 p-3 flex items-center justify-center group
                bottom-[max(1.25rem,env(safe-area-inset-bottom,0px))] right-[max(1.25rem,env(safe-area-inset-right,0px))]
                max-[380px]:bottom-[max(1.5rem,env(safe-area-inset-bottom,0px))] max-[380px]:right-[max(1.75rem,env(safe-area-inset-right,0px))]
                sm:bottom-6 sm:right-6
                transition-all duration-300 ease-out
                ${isVisible 
                    ? 'opacity-100 translate-y-0 scale-100' 
                    : 'opacity-0 translate-y-4 scale-90 pointer-events-none'
                }
                hover:scale-110 hover:shadow-xl hover:bg-alsero-first
                active:scale-95
            `}
            style={{
                animation: isVisible ? 'pulse-slow 3s ease-in-out infinite' : 'none',
                width: '48px',
                height: '48px',
            }}
            aria-label="Sayfanın başına dön"
            title="Sayfanın başına dön"
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                    className={`transition-all duration-300 ease-out
                        ${isHovered 
                            ? 'text-white translate-y-[-2px]' 
                            : 'text-alsero-first translate-y-0'
                        }
                    `}
                    style={{
                        animation: isHovered ? 'bounce-subtle 0.6s ease-in-out infinite' : 'none',
                    }}
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M10 4L4 10M10 4L16 10M10 4V16"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`transition-all duration-300
                        ${isHovered ? 'animate-bounce-subtle' : ''}
                    `}
                />
            </svg>
            
            {/* Hover efekti için glow */}
            <span 
                className={`absolute inset-0 rounded-full bg-alsero-first opacity-0 blur-md
                    transition-opacity duration-300
                    ${isHovered ? 'opacity-30' : ''}
                `}
                aria-hidden="true"
            />
        </button>
    );
}

